import { render, staticRenderFns } from "./pageContent.vue?vue&type=template&id=6b44b75a&"
import script from "./pageContent.vue?vue&type=script&lang=js&"
export * from "./pageContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports